/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AuthorizeRequestBody,
  AuthorizeRequestBody$Outbound,
  AuthorizeRequestBody$outboundSchema,
} from "../components/authorizerequestbody.js";

export type CliAuthAuthorizeSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CliAuthAuthorizeRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  authorizeRequestBody: AuthorizeRequestBody;
};

/** @internal */
export type CliAuthAuthorizeSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CliAuthAuthorizeSecurity$outboundSchema: z.ZodMiniType<
  CliAuthAuthorizeSecurity$Outbound,
  CliAuthAuthorizeSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function cliAuthAuthorizeSecurityToJSON(
  cliAuthAuthorizeSecurity: CliAuthAuthorizeSecurity,
): string {
  return JSON.stringify(
    CliAuthAuthorizeSecurity$outboundSchema.parse(cliAuthAuthorizeSecurity),
  );
}

/** @internal */
export type CliAuthAuthorizeRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AuthorizeRequestBody: AuthorizeRequestBody$Outbound;
};

/** @internal */
export const CliAuthAuthorizeRequest$outboundSchema: z.ZodMiniType<
  CliAuthAuthorizeRequest$Outbound,
  CliAuthAuthorizeRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    authorizeRequestBody: AuthorizeRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      authorizeRequestBody: "AuthorizeRequestBody",
    });
  }),
);

export function cliAuthAuthorizeRequestToJSON(
  cliAuthAuthorizeRequest: CliAuthAuthorizeRequest,
): string {
  return JSON.stringify(
    CliAuthAuthorizeRequest$outboundSchema.parse(cliAuthAuthorizeRequest),
  );
}
